import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { LocalStorageService } from '@sb-tools/typescript/services/local-storage.service';

const keyName = 'isLeftMenuOpen';

@Injectable({ providedIn: 'root' })
export class SideNavigationService {
    isLeftMenuOpen: boolean;
    leftMenuStatusUpdate = new Subject<boolean>();

    constructor(
        private activatedRoute: ActivatedRoute,
        private localStorageService: LocalStorageService,
    ) {
        if (this.activatedRoute.snapshot.queryParams.isLeftMenuClosed !== undefined) {
            this.isLeftMenuOpen = !this.activatedRoute.snapshot.queryParams.isLeftMenuClosed;
            this.localStorageService.setItem(keyName, this.isLeftMenuOpen.toString());
        } else {
            this.isLeftMenuOpen = this.localStorageService.getItem(keyName) !== 'false';
        }
    }

    toggleSidebar(): void {
        this.isLeftMenuOpen = !this.isLeftMenuOpen;
        this.localStorageService.setItem(keyName, this.isLeftMenuOpen.toString());
        this.leftMenuStatusUpdate.next(true);
    }
}
